module.exports = __webpack_public_path__ + "img/Bg.74a4dfb1.png";